import SiteCount from "./SiteCount";
import OverlayTransition from "./OverlayTransition";
import CustomTransition from "./CustomTransition";

export default [
  new SiteCount(),
  new OverlayTransition(),
  new CustomTransition(),
];
